import { render, staticRenderFns } from "./JoinSessionDialog.vue?vue&type=template&id=2230f6ad&"
import script from "./JoinSessionDialog.vue?vue&type=script&lang=js&"
export * from "./JoinSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports